import { render, staticRenderFns } from "./h-slider.vue?vue&type=template&id=12ff8ddf&scoped=true&lang=html"
import script from "./h-slider.vue?vue&type=script&lang=js"
export * from "./h-slider.vue?vue&type=script&lang=js"
import style0 from "./h-slider.vue?vue&type=style&index=0&id=12ff8ddf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ff8ddf",
  null
  
)

/* custom blocks */
import block0 from "./h-slider.vue?vue&type=custom&index=0&blockType=i18n&lang=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HLabel: require('/home/runner/work/frontpages/frontpages/component-library/src/components/atoms/forms/h-label.vue').default})
